import React from 'react';
import { Form, Input, Modal } from 'antd';
import type { FormInstance } from 'antd';
import type { LotteryRecord } from '../../types/lottery';

const { TextArea } = Input;

type Props = {
  open: boolean;
  record: LotteryRecord | null;
  form: FormInstance<{ fulfillmentNote?: string }>;
  onCancel: () => void;
  onOk: () => void;
};

const FulfillModal: React.FC<Props> = ({ open, record, form, onCancel, onOk }) => (
  <Modal title="标记兑奖" open={open} onCancel={onCancel} onOk={onOk} destroyOnClose>
    <Form form={form} layout="vertical" preserve={false}>
      <Form.Item label="中奖记录">
        <Input disabled value={record ? `${record.orderNo} / ${record.prizeName}` : ''} />
      </Form.Item>
      <Form.Item name="fulfillmentNote" label="兑奖备注">
        <TextArea rows={3} placeholder="例如：已联系用户，话费已发放。" />
      </Form.Item>
    </Form>
  </Modal>
);

export default FulfillModal;
